"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _Flyout_css = _interopRequireDefault(require("./Flyout_css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _modalUtils = require("../utils/modalUtils");
var _TabbingTrapper = _interopRequireDefault(require("../TabbingTrapper"));
// Breaks IE 11 for some reason...

// Let's create a Modal component that is an abstraction around
// the portal API.
class Flyout extends _react.default.Component {
  constructor(props) {
    super(props);

    // get the element the flyout will be injected into
    this.modalRoot = (0, _modalUtils.getModalRoot)();

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement("div");
    this.applyWrapper = this.applyWrapper.bind(this);
    this.close = this.closeFlyout.bind(this);
    this.handleFlyoutClick = this.handleFlyoutClick.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.setPositionStyles = this.setPositionStyles.bind(this);
    this.baseIsMounted = false;
    this.state = {
      positionStyles: {},
      flyoutCenteredClass: null
    };
    (0, _appendCss.default)("arc_flyout", _Flyout_css.default);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.anchorId !== this.props.anchorId || prevProps.isOpen !== this.props.isOpen) this.setPosition();
  }
  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    if (this.baseIsMounted) this.modalRoot.removeChild(this.el);
  }
  applyWrapper() {
    if (!this.baseIsMounted) {
      this.modalRoot.appendChild(this.el);
      this.baseIsMounted = true;
    }
    const flyoutOverlayClasses = (0, _classnames.default)({
      "FlyoutContainer--overlay": !this.props.useDarkOverlay,
      "FlyoutContainer--overlay-dark": this.props.useDarkOverlay
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "FlyoutContainer ".concat(this.props.variant)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: flyoutOverlayClasses,
      onClick: this.close
    }), this.props.useTabTrapping ? /*#__PURE__*/_react.default.createElement(_TabbingTrapper.default, {
      escCallback: this.close,
      focusElement: this.props.focusOnOpen
    }, this.applyContent()) : this.applyContent());
  }
  applyContent() {
    const flyoutClasses = (0, _classnames.default)({
      "FlyoutContainer--flyout": true,
      [this.state.flyoutCenteredClass]: this.state.flyoutCenteredClass,
      "no-padding": !this.props.defaultPadding,
      "fixed-position": this.props.fixedPosition
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: flyoutClasses,
      style: this.state.positionStyles,
      onClick: this.handleFlyoutClick
    }, this.props.useTabTrapping ? {
      "role": "dialog",
      "aria-modal": "true"
    } : {}), /*#__PURE__*/_react.default.createElement("div", {
      className: "FlyoutContainer--content"
    }, this.props.children));
  }
  handleFlyoutClick(evt) {
    if (this.props.closeOnClick) {
      this.close(evt);
    }
  }
  closeFlyout(evt) {
    if (this.props.onClose !== null) this.props.onClose(evt);
    // need a slight delay before finishing the close behaviors, simply to give the onClick prop time to fire.
    setTimeout(() => {
      this.setState({
        positionStyles: {},
        flyoutCenteredClass: null
      });
      (0, _modalUtils.handleFocusElement)(this.props.focusOnClose);
    }, 100);
  }
  setPosition() {
    if (!this.props.anchorId) {
      this.setPositionStyles({}, "centered");
      return;
    }
    let anchorElem = document.getElementById(this.props.anchorId);
    if (!anchorElem) {
      this.setPositionStyles({}, "centered");
      return;
    }

    // set class if topCentered or bottomCentered alignment
    this.flyoutCenteredClass = this.props.alignment.indexOf("Centered") !== -1 ? this.props.alignment : null;
    let positionStyles = (0, _modalUtils.setFlyoutPosition)(anchorElem, this.props.alignment, this.props.offset, 0, this.props.fixedPosition);
    this.setPositionStyles(positionStyles, this.flyoutCenteredClass);
  }
  setPositionStyles(positionStyles, flyoutCenteredClass) {
    this.setState({
      positionStyles,
      flyoutCenteredClass
    });
  }
  render() {
    // Use a portal to render the children into the element
    if (!this.props.isOpen) return null;
    return /*#__PURE__*/_reactDom.default.createPortal(
    // Any valid React child: JSX, strings, arrays, etc.
    this.applyWrapper(),
    // A DOM element
    this.el);
  }
}
exports.default = Flyout;
Flyout.propTypes = {
  /** Which edge of the anchor element to align the flyout to. One of ["bottomLeft", "bottomRight", "bottomCentered", "topLeft", "topRight", "topCentered"] */
  alignment: _propTypes.default.oneOf(["bottomLeft", "bottomRight", "bottomCentered", "topLeft", "topRight", "topCentered"]),
  /** The id for the element to anchor to.  If ommitted, flyout will center itself. */
  anchorId: _propTypes.default.string,
  /** Boolean to tell the flyout to close when the user clicks within the flyout. Default: false. */
  closeOnClick: _propTypes.default.bool,
  /** Boolean to apply (or not) some padding to flyout container. default: true */
  defaultPadding: _propTypes.default.bool,
  /** Boolean to tell the flyout that the anchor is, or is within, a fixed/absolute positioned element. */
  fixedPosition: _propTypes.default.bool,
  /** Conditionally show/hide flyout by passing in this prop */
  isOpen: _propTypes.default.bool,
  /** Positive or negative x/y number to adjust margin relative to alignment */
  offset: _propTypes.default.shape({
    /** offset.x: number value that will translate to margin-left or margin-right depending on alignment */
    x: _propTypes.default.number,
    /** offset.y: number value that will translate to margin-top or margin-bottom depending on alignment */
    y: _propTypes.default.number
  }),
  /** Function to call onClose of flyout */
  onClose: _propTypes.default.func,
  /** A css class name added to the this instance of the flyout */
  variant: _propTypes.default.string,
  /** Use a dark background overlay vs the default clear one */
  useDarkOverlay: _propTypes.default.bool,
  /** CSS query selector value for the element that should recieve initial focus */
  focusOnOpen: _propTypes.default.string,
  /** react REF object for the focusable element that should be refocused when the modal closes */
  focusOnClose: _propTypes.default.object,
  /** Should the flyout have tab trapping applied? */
  useTabTrapping: _propTypes.default.bool
};
Flyout.defaultProps = {
  alignment: "bottomLeft",
  anchorId: null,
  closeOnClick: false,
  defaultPadding: true,
  fixedPosition: false,
  isOpen: false,
  offset: {
    x: 0,
    y: 0
  },
  onClose: null,
  variant: "",
  useDarkOverlay: false,
  focusOnOpen: null,
  focusOnClose: null,
  useTabTrapping: false
};